import React from "react";
import styles from "./Integrations.module.css";

const Integrations = () => {
  return (
    <div className={styles.container}>
      <h1>Integrations</h1>
      <p>This is a blank Integrations page. Add your HTML and CSS here.</p>
    </div>
  );
};

export default Integrations;
